import React, { MouseEvent, useMemo } from "react";
import cx from "classnames";

import Text from "../Text";

type AnchorProps = {
  to: string;
  children?: React.ReactNode;
  className?: string;
  as?: string;
  onClick?(event: MouseEvent<HTMLButtonElement>): void | Promise<void>;
};

const Anchor = ({
  children,
  to = "",
  as = "",
  onClick,
  className,
}: AnchorProps) => {
  const classNames = cx(
    "inline-block text-tim-primary px-1 py-px underline hover:bg-gray-300 focus:bg-gray-400 transition duration-100 rounded-sm",
    className
  );

  const isExternalLink = useMemo(() => {
    return to.startsWith("https://") || to.startsWith("http://");
  }, [to]);

  const dynamicProps = useMemo(() => {
    if (as) {
      return { type: "button" };
    }
    return isExternalLink ? { href: to, target: "_blank" } : { to };
  }, [isExternalLink, to, as]);

  return (
    <Text
      as={"a"}
      className={classNames}
      draggable={false}
      onClick={onClick}
      {...dynamicProps}
    >
      {children}
    </Text>
  );
};

export default Anchor;
